import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import {
  BankTransferRecipientIbanSearchDocument,
  BankTransferRecipientIbanSearchQuery,
  BankTransferRecipientIbanSearchQueryVariables,
} from './bankTransferRecipientIbanSearch.gql';

export const useBankTransferRecipientIbanSearch = (iban?: string) => {
  const { companyProfileId } = useCompanyContext();

  const { data, ...hook } = useQuery<
    BankTransferRecipientIbanSearchQuery,
    BankTransferRecipientIbanSearchQueryVariables
  >(BankTransferRecipientIbanSearchDocument, {
    notifyOnNetworkStatusChange: true,
    skip: !companyProfileId || !iban,
    variables: {
      companyProfileId: companyProfileId ?? '',
      iban: iban ?? '',
    },
  });

  const bankTransferRecipient = data?.viewer.company.bankTransferRecipientWith;

  return { bankTransferRecipient, ...hook } as const;
};
